import { useState, useEffect } from 'react';

// This custom hook debounces a value.
function useDebounce(value, delay) {
  // State to store the debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Set up a timer to update the debounced value after the specified delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // This is the cleanup function.
    // It clears the timeout if the `value` changes before the delay has passed.
    // This is what prevents the API call from firing on every keystroke.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]); // Only re-run the effect if `value` or `delay` changes

  return debouncedValue;
}

export default useDebounce